import classnames from 'classnames/bind'
import React from 'react'

// Styles
import styles from './style.module.scss'

// Components
import ThemeCard from '@/components/pages/Mall/components/ThemeCard'

const cx = classnames.bind(styles)

const ThemeCardList = (props: any) => {
  const { themeCardList } = props

  return (
    <div className={cx('theme-card-list')}>
      {themeCardList.map((item: any, index: number) => (
        <ThemeCard key={index} index={index} {...item} />
      ))}
    </div>
  )
}

export default React.memo(ThemeCardList)
